// extracted by mini-css-extract-plugin
export default {"connection-line":"F23qfOT8XeijFGKW8tip","label":"XBfVlQMfyIlu5VKaMnq8","label-line":"bYVIFbqPGqKHqOuPrKcs"};